var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.value.companyName,
      "breadCrumbs": _vm.breadCrumbs,
      "chips": _vm.chips,
      "actions": _vm.actions
    },
    on: {
      "actionClicked": function actionClicked($event) {
        return $event.exec();
      },
      "alertClicked": function alertClicked($event) {
        return $event.exec();
      }
    }
  }), _c('v-tabs', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "info"
    }
  }), _vm._l(Object.values(_vm.CompanyTabEnum), function (tab) {
    return _c('v-tab', {
      key: 'v-tab' + tab
    }, [_vm._v(" " + _vm._s(_vm.$t("enums.CompanyTabEnum.".concat(tab))) + " ")]);
  })], 2), _c('v-divider'), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: _vm.CompanyTabEnum.OVERVIEW
  }, [_c('m-detail-view-grid', {
    attrs: {
      "detailColMd": 5
    },
    scopedSlots: _vm._u([{
      key: "details",
      fn: function fn() {
        return [_c('select-assignees', {
          staticClass: "pb-4",
          attrs: {
            "css": "width: 100%",
            "partnerId": _vm.partner.id,
            "outlined": true,
            "dense": false,
            "solo": false
          },
          on: {
            "input": _vm.onAssigneesUpdate,
            "added": _vm.onAssigneesAdded,
            "removed": _vm.onAssigneesRemoved
          },
          model: {
            value: _vm.value.assignees,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "assignees", $$v);
            },
            expression: "value.assignees"
          }
        }), _vm.coordinates ? _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', [_c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('partner-map', {
          attrs: {
            "coordinates": _vm.coordinates,
            "height": 265,
            "colour": _vm.color
          }
        })], 1)], 1)], 1) : _vm._e(), _c('m-detail-table', {
          attrs: {
            "title": _vm.$t('about'),
            "i18nPath": "objects.company",
            "item": _vm.value,
            "config": _vm.activeCompanyTableConfig
          }
        }), _c('company-detail-table', {
          attrs: {
            "value": _vm.value,
            "onDetail": _vm.goToCompanyDetailForm
          }
        }), _c('select-update-tags', {
          attrs: {
            "resource": _vm.ResourceEnum.COMPANY,
            "partnerId": _vm.value.partnerId,
            "disabled": false,
            "readonly": false
          },
          model: {
            value: _vm.value,
            callback: function callback($$v) {
              _vm.value = $$v;
            },
            expression: "value"
          }
        }), _c('v-select', {
          staticClass: "mt-4",
          attrs: {
            "item-value": "id",
            "items": _vm.groups,
            "label": _vm.$t('objects.company.groupId'),
            "outlined": "",
            "clearable": "",
            "loading": _vm.isLoadingCompanyGroup
          },
          on: {
            "change": _vm.saveGroup,
            "click": _vm.refreshCompanyGroups
          },
          scopedSlots: _vm._u([{
            key: "append",
            fn: function fn() {
              return [_c('company-group-create-dialog', {
                attrs: {
                  "partnerId": _vm.value.partnerId
                },
                on: {
                  "created": function created(companyGroup) {
                    return _vm.value.groupId = companyGroup.id;
                  }
                },
                scopedSlots: _vm._u([{
                  key: "activator",
                  fn: function fn(_ref) {
                    var on = _ref.on;
                    return [_c('v-btn', {
                      staticStyle: {
                        "position": "relative",
                        "top": "-6px"
                      },
                      attrs: {
                        "icon": "",
                        "loading": _vm.isLoadingCompanyGroups
                      },
                      on: {
                        "click": function click($event) {
                          $event.stopPropagation();
                          return on.apply(null, arguments);
                        }
                      }
                    }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
                  }
                }])
              })];
            },
            proxy: true
          }, {
            key: "item",
            fn: function fn(_ref2) {
              var item = _ref2.item;
              return [_vm._v(" " + _vm._s(item.title) + " ")];
            }
          }, {
            key: "selection",
            fn: function fn(_ref3) {
              var item = _ref3.item;
              return [_vm._v(" " + _vm._s(item.title) + " ")];
            }
          }]),
          model: {
            value: _vm.value.groupId,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "groupId", $$v);
            },
            expression: "value.groupId"
          }
        }), _c('div', {
          staticClass: "mt-n7",
          staticStyle: {
            "display": "flex"
          }
        }, [_c('v-spacer'), _c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "elevation": 0,
            "loading": _vm.isLoadingCompanyGroups
          },
          on: {
            "click": _vm.refreshCompanyGroups
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.refresh")) + " ")]), _c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "elevation": 0
          },
          on: {
            "click": _vm.goToCompanyGroupCustomView
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.view")) + " ")])], 1), _vm.companyGroup && _vm.companyGroup.configuration && _vm.companyGroup.configuration.customFieldConfig && _vm.companyGroup.configuration.customFieldConfig.length ? _c('div', [_vm.isLoadingCustomFieldValues ? _c('v-progress-linear', {
          attrs: {
            "indeterminate": ""
          }
        }) : _c('v-divider'), _c('custom-field-list-form', {
          staticClass: "mt-6",
          attrs: {
            "customFieldConfig": _vm.companyGroup.configuration.customFieldConfig
          },
          on: {
            "change": _vm.debounceSaveCustomFields
          },
          model: {
            value: _vm.value.values,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "values", $$v);
            },
            expression: "value.values"
          }
        })], 1) : _vm._e()];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function fn() {
        return [_c('v-divider', {
          staticClass: "mt-6"
        }), _c('m-action-list', {
          attrs: {
            "actions": _vm.bottomActions
          },
          on: {
            "actionClicked": function actionClicked($event) {
              return $event.exec();
            }
          }
        })];
      },
      proxy: true
    }])
  }, [_c('v-row', [_c('v-col', [_c('has-description', {
    staticClass: "mx-2",
    attrs: {
      "isPlainText": false
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1)], 1), _c('activity-card', {
    staticClass: "mt-5",
    attrs: {
      "partner": _vm.partner,
      "source": _vm.source,
      "config": {
        comment: true,
        mail: false
      }
    }
  })], 1)], 1), _c('v-tab-item', {
    key: _vm.CompanyTabEnum.PEOPLE_TABLE
  }, [_c('person-table', {
    attrs: {
      "filters": _vm.companyTableFilters,
      "partnerId": _vm.value.partnerId,
      "controlElements": _vm.personTableControlElements,
      "companyId": _vm.companyId
    },
    scopedSlots: _vm._u([{
      key: "bodyActions",
      fn: function fn() {
        return [_c('v-btn', {
          staticClass: "ml-2",
          attrs: {
            "elevation": "0"
          },
          on: {
            "click": function click($event) {
              _vm.isAddContactDialogOpen = true;
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("add")))])];
      },
      proxy: true
    }])
  })], 1), _c('v-tab-item', {
    key: _vm.CompanyTabEnum.REFERENCES
  }, [_c('refs-select', {
    ref: "refsSelect",
    staticClass: "mx-2 mt-4",
    attrs: {
      "partnerId": _vm.value.partnerId,
      "loading": _vm.isLoadingRefs,
      "suggested": [],
      "listMode": false,
      "hideEditButton": false,
      "categories": _vm.refsCategories,
      "hideSuggestions": true
    },
    on: {
      "confirm": _vm.saveRefs,
      "change": _vm.saveRefs,
      "input": _vm.saveRefs
    },
    model: {
      value: _vm.value.refs,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "refs", $$v);
      },
      expression: "value.refs"
    }
  }), !_vm.value.refs || !_vm.value.refs.length ? _c('v-card', {
    staticClass: "ma-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-list-item', {
    on: {
      "click": _vm.openAddReference
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(" mdi-attachment ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("common.nouns.references")) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.$t("add")) + " ")])], 1)], 1)], 1) : _vm._e()], 1), _c('v-tab-item', {
    key: _vm.CompanyTabEnum.CONTRACT_TABLE
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("objects.contract.clientIds")) + " ")]), _c('contract-table', {
    attrs: {
      "store": _vm.ContractClientModule,
      "filters": _vm.contractClientTableFilters,
      "partnerId": _vm.value.partnerId,
      "clientIds": [{
        refId: _vm.value.id,
        refType: _vm.ResourceEnum.COMPANY
      }]
    },
    scopedSlots: _vm._u([{
      key: "bodyActions",
      fn: function fn() {
        return [_c('Can', {
          attrs: {
            "I": _vm.ActionEnum.UPDATE,
            "a": _vm.ResourceEnum.CONTRACT,
            "field": _vm.value.partnerId
          }
        }, [_c('contract-select-by-client-or-provider-update-dialog', {
          staticClass: "ml-2",
          attrs: {
            "title": _vm.$t('contract.addClient'),
            "isProvider": false,
            "partnerId": _vm.value.partnerId,
            "hideButton": false,
            "refs": [{
              refId: _vm.value.id,
              refType: _vm.ResourceEnum.COMPANY
            }]
          }
        })], 1)];
      },
      proxy: true
    }])
  }), _c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("objects.contract.providerIds")) + " ")]), _c('contract-table', {
    attrs: {
      "store": _vm.ContractProviderModule,
      "filters": _vm.contractProviderTableFilters,
      "partnerId": _vm.value.partnerId,
      "providerIds": [{
        refId: _vm.value.id,
        refType: _vm.ResourceEnum.COMPANY
      }]
    },
    scopedSlots: _vm._u([{
      key: "bodyActions",
      fn: function fn() {
        return [_c('Can', {
          attrs: {
            "I": _vm.ActionEnum.UPDATE,
            "a": _vm.ResourceEnum.CONTRACT,
            "field": _vm.value.partnerId
          }
        }, [_c('contract-select-by-client-or-provider-update-dialog', {
          staticClass: "ml-2",
          attrs: {
            "title": 'contract.addProvider',
            "isProvider": true,
            "partnerId": _vm.value.partnerId,
            "hideButton": false,
            "refs": [{
              refId: _vm.value.id,
              refType: _vm.ResourceEnum.COMPANY
            }]
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1), _c('v-tab-item', {
    key: _vm.CompanyTabEnum.BANKING
  }, [_c('v-row', [_c('v-col', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("objects.datevAccount.title")) + " ")]), _vm.value.accounts ? _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm.value.accounts.creditorAccountNumber ? _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.datevAccount.creditorAccountNumber'),
      "readonly": true
    },
    model: {
      value: _vm.value.accounts.creditorAccountNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.value.accounts, "creditorAccountNumber", $$v);
      },
      expression: "value.accounts.creditorAccountNumber"
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm.value.accounts.debtorAccountNumber ? _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.datevAccount.debtorAccountNumber'),
      "readonly": true
    },
    model: {
      value: _vm.value.accounts.debtorAccountNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.value.accounts, "debtorAccountNumber", $$v);
      },
      expression: "value.accounts.debtorAccountNumber"
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm.canCreateDatevAccount ? _c('v-card-actions', [!_vm.value.accounts || !_vm.value.accounts.creditorAccountNumber ? _c('v-btn', {
    staticClass: "mx-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": _vm.makeCreditor
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.datevAccount.makeCreditor")) + " ")]) : _vm._e(), !_vm.value.accounts || !_vm.value.accounts.debtorAccountNumber ? _c('v-btn', {
    staticClass: "mx-2",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": _vm.makeDebtor
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.datevAccount.makeDebtor")) + " ")]) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1), _c('v-row', [_c('v-col', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("objects.contract.customer.billing")) + " "), _c('v-spacer'), _c('m-icon-button', {
    attrs: {
      "icon": "mdi-trash-can",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.removeBillingProfile
    }
  }), _c('m-icon-button', {
    on: {
      "click": _vm.addBillingProfile
    }
  })], 1), _vm.value.billingProfile ? _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.person.billingProfile.paymentTerm'),
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.value.billingProfile.paymentTerm,
      callback: function callback($$v) {
        _vm.$set(_vm.value.billingProfile, "paymentTerm", $$v);
      },
      expression: "value.billingProfile.paymentTerm"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-select', {
    attrs: {
      "items": Object.values(_vm.CurrencyEnum),
      "label": _vm.$t('objects.contract.currency'),
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.value.billingProfile.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.value.billingProfile, "currency", $$v);
      },
      expression: "value.billingProfile.currency"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.email'),
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.value.billingProfile.email,
      callback: function callback($$v) {
        _vm.$set(_vm.value.billingProfile, "email", $$v);
      },
      expression: "value.billingProfile.email"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.purchaseOrderNumber'),
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.value.billingProfile.purchaseOrderNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.value.billingProfile, "purchaseOrderNumber", $$v);
      },
      expression: "value.billingProfile.purchaseOrderNumber"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.invoiceSubjectLine'),
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.value.billingProfile.invoiceSubjectLine,
      callback: function callback($$v) {
        _vm.$set(_vm.value.billingProfile, "invoiceSubjectLine", $$v);
      },
      expression: "value.billingProfile.invoiceSubjectLine"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": _vm.$t('objects.person.billingProfile.note'),
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.value.billingProfile.note,
      callback: function callback($$v) {
        _vm.$set(_vm.value.billingProfile, "note", $$v);
      },
      expression: "value.billingProfile.note"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.billingType'),
      "items": _vm.billingTypeItems,
      "item-text": "text",
      "item-value": "value",
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.value.billingProfile.type,
      callback: function callback($$v) {
        _vm.$set(_vm.value.billingProfile, "type", $$v);
      },
      expression: "value.billingProfile.type"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-select', {
    attrs: {
      "label": _vm.$t('objects.contract.customer.billingMode'),
      "items": _vm.billingModeItems,
      "item-text": "text",
      "item-value": "value",
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.value.billingProfile.mode,
      callback: function callback($$v) {
        _vm.$set(_vm.value.billingProfile, "mode", $$v);
      },
      expression: "value.billingProfile.mode"
    }
  })], 1)], 1)], 1) : _c('v-card-text', [_c('m-no-content', {
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('v-btn', {
          staticClass: "mx-2 px-4",
          attrs: {
            "outlined": ""
          },
          on: {
            "click": _vm.addBillingProfile
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("add")) + " ")], 1)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1), _c('partner-has-partner-banking-ids-table', {
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isBillingProfileDialogActive,
      "title": _vm.$t('objects.contract.customer.billing'),
      "loading": _vm.isLoading,
      "hideLeft": true,
      "rightDisabled": !_vm.isBillingProfileValid,
      "rightLoading": _vm.isLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isBillingProfileDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isBillingProfileDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isBillingProfileDialogActive = false;
      },
      "rightClick": _vm.updateBillingProfile
    }
  }, [_vm.newBillingProfile ? _c('v-form', {
    model: {
      value: _vm.isBillingProfileValid,
      callback: function callback($$v) {
        _vm.isBillingProfileValid = $$v;
      },
      expression: "isBillingProfileValid"
    }
  }, [_c('billing-profile-form', {
    model: {
      value: _vm.newBillingProfile,
      callback: function callback($$v) {
        _vm.newBillingProfile = $$v;
      },
      expression: "newBillingProfile"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm.isDeleteDialogActive && _vm.value ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('partner.PartnerReportDetailChangeProgress.confirmDeleteTitle'),
      "rightColor": 'error',
      "loading": _vm.isDeleteLoading,
      "rightLoading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isDeleteDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.onDelete
    }
  }, [_c('refs-company', {
    attrs: {
      "item": _vm.value
    }
  })], 1) : _vm._e(), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("components.PartnerReportDetail.contact.addContact"),
      "isDialogActive": _vm.isAddContactDialogOpen,
      "rightLoading": _vm.isAddContactLoading,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isAddContactDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isAddContactDialogOpen = $event;
      },
      "rightClick": _vm.addContact
    }
  }, [_c('person-selection', {
    attrs: {
      "cache": false
    },
    model: {
      value: _vm.contactToAdd,
      callback: function callback($$v) {
        _vm.contactToAdd = $$v;
      },
      expression: "contactToAdd"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }